<template>
    <b-container fluid>
        <b-row>
            <b-col xl="12" lg="12" sm="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('external_sidebar.delivery_order_receive') + ' ' + $t('production_store.details') }}</h4>
                    </template>
                    <template v-slot:headerAction>
                        <router-link v-if="view === true" to="delivery-order-receive" :class="'btn btn-primary text-light'"><i class="ri-file-text-line"></i>{{  $t('external_sidebar.delivery_order_receive') + ' ' + $t('globalTrans.list') }}</router-link>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loading">
                            <b-row v-if="view === true">
                                <div class="mt-4 col-lg-12 col-sm-12 col-md-12">
                                    <b-col lg="12" sm="12" class="form-for-textarea">
                                        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                        <b-form  @submit.prevent="handleSubmit(createData)" @reset.prevent="reset"  enctype="multipart/form-data">
                                            <b-table-simple striped bordered small>
                                                <b-tr style="background-color: #66CC99; color: white">
                                                    <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                                                    <b-th>{{ $t('retailerManagement.product_name') }}</b-th>
                                                    <b-th>{{ $t('retailerManagement.unit') }}</b-th>
                                                    <b-th>{{ $t('retailerManagement.request_quantity') }}</b-th>
                                                    <b-th>{{ $t('retailerManagement.unit_price') }}</b-th>
                                                    <b-th>{{ $t('retailerManagement.total_price') }}</b-th>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td>1</b-td>
                                                    <b-td>test</b-td>
                                                    <b-td>unit test</b-td>
                                                    <b-td>120</b-td>
                                                    <td>120</td>
                                                    <td>450</td>
                                                </b-tr>
                                                <b-tr>
                                                    <b-td>2</b-td>
                                                    <b-td>test</b-td>
                                                    <b-td>unit test</b-td>
                                                    <b-td>155</b-td>
                                                    <td>250</td>
                                                    <td>24544</td>
                                                </b-tr>
                                                <b-td colspan="5">
                                                    <p style="margin-left:85%">Grand Price</p>
                                                </b-td>
                                                <td></td>
                                            </b-table-simple>
                                        </b-form>
                                        </ValidationObserver>
                                    </b-col>
                                </div>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
// import { core } from '@/config/pluginInit'
// import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { authServiceBaseUrl } from '@/config/api_config'
import { userListApi } from '../../../../../../production-service/sales-distribution-admin/api/routes'
import flatpickr from 'flatpickr'
// import moment from 'moment'

export default {
    props: ['id'],
    components: {
        // ValidationObserver,
        // ValidationProvider
    },
    data () {
        return {
            saveBtnName: this.mat_id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            detailsFormData: {
                sales_center_id: 0,
                year: 0,
                month: 0,
                from_date: '',
                to_date: '',
                req_quantity: '',
                remark_en: '',
                remark_bn: ''
            },
            dataArray: {
                requisition_id: '',
                requisition_date: '',
                useable_area: '',
                useable_area_bn: '',
                details: [],
                forward: {
                    org_id: '1',
                    designation_id: '',
                    forward_date: '',
                    employee_id: '',
                    note: '',
                    note_bn: ''
                }
            },
            mat_id: 0,
            sl: 0,
            view: false,
            view_sales: false,
            addForward: true,
            subCategoryList: [],
            productList: [],
            productUnitList: [],
            // designationList: [],
            userList: [],
            loading: false,
            unitLoad: false,
            total_qty: '',
            totalPrice: 0
        }
    },
    watch: {
        'detailsFormData.sales_center_id': function (newVal, oldVal) {
            this.salesCenterList = this.getSalesCenterList(newVal)
        },
        'detailsFormData.year': function (newVal, oldVal) {
            this.productUnitList = this.getProductUnitList(newVal)
        },
        'dataArray.forward.org_id': function (newVal, oldVal) {
            this.designationList = this.getDesignationList(newVal)
        },
        'dataArray.forward.designation_id': function (newVal, oldVal) {
            this.getUserList(newVal)
        },
        currentLocale: function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.localizeUserList(newVal)
            }
        }
    },
    computed: {
        salesCenterList: function () {
            return this.productCommonObj.salesCenterList
        },
        designationList: function () {
            return this.productCommonObj.designationInfoList
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(year => year.status === 0)
        },
        MonthList: function () {
          const list = [
            { value: 1, text: this.$t('months.jan') },
            { value: 2, text: this.$t('months.feb') },
            { value: 3, text: this.$t('months.mar') },
            { value: 4, text: this.$t('months.apr') },
            { value: 5, text: this.$t('months.may') },
            { value: 6, text: this.$t('months.jun') },
            { value: 7, text: this.$t('months.jul') },
            { value: 8, text: this.$t('months.aug') },
            { value: 9, text: this.$t('months.sep') },
            { value: 10, text: this.$t('months.oct') },
            { value: 11, text: this.$t('months.nov') },
            { value: 12, text: this.$t('months.dec') }
          ]
          return list
        },
        orgList: function () {
            return this.$store.state.orgList.filter(item => item.status === 0)
        },
        currentLocale: function () {
            return this.$i18n.locale
        },
        ...mapGetters({
            productCommonObj: 'ProductionService/commonObj'
        })
    },
    mounted () {
            flatpickr('#requisition_date', {})
            flatpickr('#forward_date', {})
            // this.getRequisitionId()
    },
    created () {
        if (this.$route.query.view) {
            this.view_sales = false
            this.view = true
            this.addForward = false
        }
        if (this.$route.query.view_sales) {
            this.view_sales = true
            this.view = false
            this.addForward = false
        }
        if (this.$route.query.id) {
            this.mat_id = this.$route.query.id
            this.getRequisitionInfoData(this.$route.query.id)
            this.addForward = false
        }
    },
    methods: {
        deleteItem (index) {
            this.dataArray.details.splice(index, 1)
        },
        cancel () {
          if (this.mat_id) {
              this.$router.push({ path: '/production-service/store-management/raw-material-requisition-list' })
          } else {
              this.detailsFormData = {
                    sales_center_id: 0,
                    year: 0,
                    month: 0,
                    req_quantity: '',
                    remark_en: '',
                    remark_bn: ''
                }
                this.dataArray.requisition_date = ''
                this.dataArray.useable_area = ''
                this.dataArray.useable_area_bn = ''
                this.dataArray.details = []
          }
        },
        addItem () {
            if (this.detailsFormData.sales_center_id !== 0 && this.detailsFormData.year !== 0 && this.detailsFormData.month !== 0 && this.detailsFormData.req_quantity !== '') {
                const existsTarget = this.dataArray.details.some(data => data.sales_center_id === this.detailsFormData.sales_center_id)
                const existsYear = this.dataArray.details.some(data => data.year === this.detailsFormData.year)
                const existsMonth = this.dataArray.details.some(data => data.month === this.detailsFormData.month)
                if (existsTarget && existsYear && existsMonth) {
                    this.dataArray.details.forEach((result, index) => {
                        if (result.sales_center_id === this.detailsFormData.sales_center_id && result.year === this.detailsFormData.year && result.month === this.detailsFormData.month) {
                            const totalVal = parseInt(result.req_quantity) + parseInt(this.detailsFormData.req_quantity)
                            this.dataArray.details[index].req_quantity = totalVal
                            this.dataArray.details[index].remark_en = this.detailsFormData.remark_en
                            this.dataArray.details[index].remark_bn = this.detailsFormData.remark_bn
                            this.detailsFormData = {
                                sales_center_id: 0,
                                year: 0,
                                month: 0,
                                req_quantity: '',
                                remark_en: '',
                                remark_bn: ''
                            }
                        }
                    })
                } else {
                    this.dataArray.details.push(this.detailsFormData)
                    this.detailsFormData = {
                        sales_center_id: 0,
                        year: 0,
                        month: 0,
                        req_quantity: '',
                        remark_en: '',
                        remark_bn: ''
                    }
                }
            }
        },
        async saveData () {
            // this.$store.dispatch('mutateCommonProperties', { loading: true })
            // let result = null
            // const loadingState = { loading: false, listReload: false }
            // if (this.mat_id) {
            //     result = await RestApi.putData(productionServiceBaseUrl, `${materialRequisitionUpdateApi}/${this.mat_id}`, this.dataArray)
            // } else {
            //     result = await RestApi.postData(productionServiceBaseUrl, materialRequisitionStoreApi, this.dataArray)
            // }

            // loadingState.listReload = true
            // this.$store.dispatch('mutateCommonProperties', loadingState)

            // if (result.success) {
            //     this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
            //     this.$toast.success({
            //         title: this.$t('globalTrans.success'),
            //         message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
            //         color: '#D6E09B'
            //     })
            //     this.$router.push({ path: '/production-service/store-management/raw-material-requisition-list' })
            // } else {
            //     this.$refs.form.setErrors(result.errors)
            // }
        },
        getSalesCenterList (id = null) {
            const productList = this.$store.state.ProductionService.commonObj.salesCenterList
            if (id) {
                return productList.filter(salesCenter => salesCenter.value === id)
            }
            return productList
        },
        salesCenterNameById (id) {
            const category = this.productCommonObj.salesCenterList.find(center => center.value === id)
            if (this.$i18n.locale === 'bn') {
                return category.text_bn
            } else {
               return category.text_en
            }
        },
        productSubCategoryById (id) {
            const subCategory = this.productCommonObj.productSubCategoryList.find(subCategory => subCategory.value === id)
            if (this.$i18n.locale === 'bn') {
                return subCategory.text_bn
            } else {
               return subCategory.text_en
            }
        },
        yearNameById (id) {
            const product = this.fiscalYearList.find(product => product.value === id)
            if (this.$i18n.locale === 'bn') {
                return product.text
            } else {
               return product.text
            }
        },
        monthNameById (id) {
            const unit = this.MonthList.find(unit => unit.value === id)
            if (this.$i18n.locale === 'bn') {
                return unit.text
            } else {
               return unit.text
            }
        },
        padString (serial) {
            var str = '' + serial
            var pad = '0000'
            var ans = pad.substring(0, pad.length - str.length) + str
            return ans
        },
        getDesignationList () {
        },
        getUserList (designationId = null) {
            RestApi.getData(authServiceBaseUrl, `${userListApi}/${designationId}`).then(response => {
                const userList = response.map((obj, index) => {
                  return Object.assign({}, obj, {
                    text: this.currentLocale === 'en' ? obj.text_en : obj.text_bn
                  })
                })
                this.userList = userList
                return userList
            })
        }
    }
}
</script>
